"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderBreadcrumb = exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _tslib = require("tslib");
var _categoryProduct = require("@/api/category-product");
var _product = require("@/api/product");
var _store = require("@/api/store");
var _vuePropertyDecorator = require("vue-property-decorator");
var _OrderProductHistory = _interopRequireDefault(require("./OrderProductHistory.vue"));
var _ProductInfoForm = _interopRequireDefault(require("./ProductInfoForm.vue"));
var _productGallery = require("@/api/product-gallery");
var _ProductProperty = _interopRequireDefault(require("./ProductProperty.vue"));
var _moment = _interopRequireDefault(require("moment"));
var renderBreadcrumb = exports.renderBreadcrumb = function renderBreadcrumb(category) {
  var breadcrumb = [];
  Object.keys(category).forEach(function (key) {
    if (key.includes("parent") && category[key]) {
      breadcrumb.push(category[key].name);
    }
  });
  return "Level ".concat(category.level, " | ").concat(category.name, " ").concat(breadcrumb.length ? "(".concat(breadcrumb.join(" / "), ")") : "", " ");
};
var ProductModal = /*#__PURE__*/function (_Vue) {
  function ProductModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ProductModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ProductModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "tabName", "info");
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      originPrice: 0,
      finalPrice: 0
    });
    (0, _defineProperty2.default)(_this, "stepActive", 1);
    (0, _defineProperty2.default)(_this, "galaries", []);
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      storeId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      sku: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      originPrice: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      finalPrice: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      productCategoryId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      colorIds: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      sizeIds: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "colors", []);
    (0, _defineProperty2.default)(_this, "sizes", []);
    (0, _defineProperty2.default)(_this, "categories", []);
    (0, _defineProperty2.default)(_this, "stores", []);
    return _this;
  }
  (0, _inherits2.default)(ProductModal, _Vue);
  return (0, _createClass2.default)(ProductModal, [{
    key: "handleDeleteImage",
    value: function handleDeleteImage(_ref) {
      var _this2 = this;
      var file = _ref.file;
      _productGallery.productGalleryApi.delete(file.galleryId).then(function (res) {
        _this2.$notify.success({
          title: "Delete image",
          message: "Successfully"
        });
      });
    }
  }, {
    key: "handleUploadOk",
    value: function handleUploadOk(_ref2) {
      var _this3 = this;
      var path = _ref2.path,
        file = _ref2.file,
        fileList = _ref2.fileList;
      _product.productApi.addImage(this.form.id, {
        image: path
      }).then(function (res) {
        _this3.$notify.success({
          title: "Add image",
          message: "Successfully"
        });
        _this3.$emit("submit:success");
        var tmp = fileList.find(function (e) {
          return e.uid == file.uid;
        });
        if (tmp) {
          tmp.galleryId = res.data.id;
        }
      });
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$confirm("Confirm delete this product?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.loadingSubmit = true;
              _context.next = 6;
              return _product.productApi.remove(this.form.id);
            case 6:
              this.$notify.success({
                title: "Delete product",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context.prev = 9;
              this.loadingSubmit = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleBlurOriginPrice",
    value: function handleBlurOriginPrice() {
      if (!this.form.finalPrice) {
        this.form.finalPrice = this.form.originPrice;
      }
    }
  }, {
    key: "fetchStores",
    value: function fetchStores() {
      var _this4 = this;
      _store.storeApi.findAll().then(function (res) {
        return _this4.stores = res.data.stores;
      });
    }
  }, {
    key: "created",
    value: function created() {}
  }, {
    key: "fetchCategories",
    value: function fetchCategories() {
      var _this5 = this;
      _categoryProduct.categoryProductApi.findAll().then(function (res) {
        _this5.categories = res.data.data;
      });
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var valid, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$refs.productInfoForm.$refs.form.validate();
            case 2:
              valid = _context2.sent;
              if (!valid) {
                _context2.next = 16;
                break;
              }
              _context2.prev = 4;
              this.loadingSubmit = true;
              data = {
                product: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
                  expired: (0, _moment.default)(this.form.expired).unix()
                }),
                productCategoryId: this.form.productCategoryId,
                shopeeProductIds: this.form.shopeeProductIds,
                shopifyProductIds: this.form.shopifyProductIds
                // shopeeProductId: this.form.shopeeProductId,
                // shopifyProductId: this.form.shopifyProductId,
              };
              console.log("data ne", data);
              _context2.next = 10;
              return _product.productApi.create(data);
            case 10:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 13:
              _context2.prev = 13;
              this.loadingSubmit = false;
              return _context2.finish(13);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4,, 13, 16]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var form, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              this.loadingSubmit = true;
              form = (0, _objectSpread2.default)({}, this.form);
              delete form.productGalleries;
              data = {
                product: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  expired: (0, _moment.default)(this.form.expired).unix()
                }),
                productCategoryId: this.form.productCategoryId,
                // shopeeProductId: this.form.shopeeProductId || 0,
                // shopifyProductId: this.form.shopifyProductId || 0,
                shopeeProductIds: this.form.shopeeProductIds || [],
                shopifyProductIds: this.form.shopifyProductIds || []
              };
              _context3.next = 7;
              return _product.productApi.update(this.form.id, data);
            case 7:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 10:
              _context3.prev = 10;
              this.loadingSubmit = false;
              return _context3.finish(10);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0,, 10, 13]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function () {
      var _handleCreate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.fetchCategories();
              this.visible = true;
              this.status = "create";
              this.form = {
                originPrice: 0,
                finalPrice: 0,
                colorIds: [],
                expired: (0, _moment.default)().valueOf()
              };
              this.stepActive = 1;
              this.tabName = "info";
              _context4.next = 8;
              return this.$nextTick();
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleCreate() {
        return _handleCreate.apply(this, arguments);
      }
      return handleCreate;
    }()
  }, {
    key: "fetchProduct",
    value: function () {
      var _fetchProduct = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var _res$data$shopeeProdu,
          _res$data$shopifyProd,
          _this6 = this;
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _product.productApi.findOne(this.form.id);
            case 2:
              res = _context5.sent;
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, res.data), {}, {
                productCategoryId: res.data.productCategory && res.data.productCategory.id,
                shopeeProductIds: (_res$data$shopeeProdu = res.data.shopeeProducts) === null || _res$data$shopeeProdu === void 0 ? void 0 : _res$data$shopeeProdu.map(function (item) {
                  return item === null || item === void 0 ? void 0 : item.id;
                }),
                shopifyProductIds: (_res$data$shopifyProd = res.data.shopifyProducts) === null || _res$data$shopifyProd === void 0 ? void 0 : _res$data$shopifyProd.map(function (item) {
                  return item === null || item === void 0 ? void 0 : item.id;
                }),
                // shopeeProductId: res.data.shopeeProduct?.id,
                // shopifyProductId: res.data.shopifyProduct?.id,
                expired: _moment.default.unix(res.data.expired).valueOf()
              });
              _context5.next = 6;
              return this.$nextTick();
            case 6:
              this.$refs.productInfoForm.fileList = res.data.productGalleries.map(function (e) {
                return {
                  name: e.image,
                  url: _this6.$baseUrlMedia + e.image,
                  galleryId: e.id
                };
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchProduct() {
        return _fetchProduct.apply(this, arguments);
      }
      return fetchProduct;
    }()
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.fetchCategories();
              this.visible = true;
              this.stepActive = 1;
              this.status = "update";
              this.tabName = "info";
              this.form = (0, _objectSpread2.default)({}, data);
              this.fetchProduct();
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleUpdate(_x) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.$refs.productInfoForm.fileList = [];
    }
  }]);
}(_vuePropertyDecorator.Vue);
ProductModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductInfoForm: _ProductInfoForm.default,
    OrderProductHistory: _OrderProductHistory.default,
    ProductProperty: _ProductProperty.default
  }
})], ProductModal);
var _default = exports.default = ProductModal;